import { FC } from 'react'
import styles from './styles.module.scss'
import { Colour } from '../../../constants'
import { QRCodeForm, QRCodeFormProps } from './QRCodeForm'
import { OpenAccountPage } from '@/components/OpenAccountFlow/OpenAccountPage'
import { OnboardingProcess } from '../../../../../conf/env'
import { Panel } from '@/components/Panel/Panel'
import { PanelItem } from '@/components/Panel/PanelItem'
import { useOnboardingProcess } from '@/hooks/useOnboardingProcess'
import { useConfig } from '@/hooks/useConfig'
import { Supports } from '../../components/Supports'

interface FormComponentMap {
  [OnboardingProcess.QR]: FC<QRCodeFormProps>
  [OnboardingProcess.OPEN_ACCOUNT]: FC<Record<string, never>>
}

export type OnboardingDesktopFormProps = Record<string, never>

const formComponentMap: FormComponentMap = {
  [OnboardingProcess.QR]: QRCodeForm,
  [OnboardingProcess.OPEN_ACCOUNT]: OpenAccountPage,
}

export const OnboardingDesktop: FC<OnboardingDesktopFormProps> = ({}) => {
  const config = useConfig()
  const { process } = useOnboardingProcess()

  const activeProcess: OnboardingProcess =
    process ?? config?.ONBOARDING_PROCESS ?? OnboardingProcess.QR
  const FormComponent = formComponentMap[activeProcess]

  return (
    <section data-testid="onboarding-desktop" className={styles.onboard}>
      <Panel short colour={Colour.warmStone} className={styles.panel}>
        <FormComponent />
      </Panel>
      <Panel short colour={Colour.warmStone}>
        <PanelItem>
          <div className={styles.bottom}>
            <Supports />
          </div>
        </PanelItem>
      </Panel>
    </section>
  )
}
